import axios from "axios";
import * as ActionType from "./category.type";
import { setToast } from "../../../util/toast";
import { apiInstanceFetch } from "../../../util/api";

export const getCategoryApi =
  (start, limit, startDate, endDate) => async (dispatch) => {
    try {
      if (!start || !limit || !startDate || !endDate) {
        setToast("error", "Missing required parameters");
        return;
      }

      const response = await apiInstanceFetch.get(
        `admin/category?start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`,
      );

      dispatch({
        type: ActionType.GET_CATEGORY, 
        payload: {
          category: response.data.category,
          total: response.data.totalCategories
        }
      });
    } catch (error) {
      console.error("Get Categories Error:", error);
      setToast("error", "Failed to fetch categories. Please try again.");
    }
  };

export const createCategory = (formData) => async (dispatch) => {
  try {
    if (!formData.categoryName || !formData.categoryStatus) {
      setToast("error", "Category name and status are required");
      return;
    }

    const response = await axios.post("admin/category/create", formData);

    if (response.data.status) {
      dispatch({
        type: ActionType.ADD_CATEGORY,
        payload: response.data.category,
      });
      setToast("success", "Category created successfully!");
    } else {
      setToast("error", response.message);
    }
  } catch (error) {
    console.error("Create Category Error:", error);
    setToast("error", "Failed to create category. Please try again.");
  }
};

export const editCategory = (data, categoryId) => (dispatch) => {
  axios
    .patch(`admin/category/update?categoryId=${categoryId}`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.EDIT_CATEGORY,
          payload: { data: res.data.category, categoryId: categoryId },
        });
        setToast("success", "Category Edit SuccessFully");
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const deleteCategory = (id) => (dispatch) => {
  axios
    .delete(`admin/category/deleteCategory?categoryId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.DELETE_CATEGORY, payload: id });
        setToast("success", "Category Delete SuccessFully");
      }
    })
    .catch((error) => console.log("error", error.message));
};
